module.exports = __webpack_public_path__ + "img/youzan_ss.482fcf2f.png";